import { render } from "./Stats.vue?vue&type=template&id=45ba463b&scoped=true&ts=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"

import "./Stats.vue?vue&type=style&index=0&id=45ba463b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ba463b"]])